export default __webpack_public_path__ + "static/media/guide_play_2.9773ce33.jpg";